fx.ns("shared.components", class CoverThumbText extends shared.components.CoverThumb 
{    
    constructor(parameters)
    {
        super(parameters);
    }

    // The font the stage gives the text where its content names none : the component's
    // font_family, set on the editor's root by TextEditor.setDefaultStyle (Text._updateDefaultStyle).
    // A title typed in one font often carries no font in its spans at all, so drawing it without
    // this fell back to the browser's serif, wider than the font chosen, and the last letters
    // wrapped out of the box ("Carcassonn").
    static defaultFont(fonts, component)
    {
        if (!fonts)
            return null;

        return fonts.find({ id : component.font_family || 1 }) || fonts.find({ id : 1 });
    }

    load()
    {
        super.load();

        let content = this.data.content || "";

        let div = document.createElement("div");
        div.innerHTML = content;
        let contentText = div.innerText.trim();

        if (fx.get("app") == "config" && contentText == "")
        {
            this.context.save();

            this.context.translate(this.elementX-this.offset, this.elementY-this.voffset);
            this.context.rotate(this.elementRotation*this.TO_RADIANS);
            this.context.translate(-(this.elementX-this.offset), -(this.elementY-this.voffset));
            
            this.context.fillStyle = '#ffffff';
            this.context.globalAlpha = 0.8;
            this.context.fillRect(this.elementX,this.elementY,this.elementWidth,this.elementHeight);
            this.context.globalAlpha = 1.0;

            this.context.fillStyle = 'transparent';
            this.context.strokeStyle = '#000000';
            this.context.lineWidth = 1;
            let spacing = 10;
            // Draw horizontal lines with specified spacing
            for (let y = this.elementY; y <= this.elementY + this.elementHeight; y += spacing) 
            {
                this.context.beginPath();
                this.context.moveTo(this.elementX, y);
                this.context.lineTo(this.elementX + this.elementWidth, y);
                this.context.stroke();
            }
            
            this.context.restore();

            this.ready();
            return;
        }

        if(content == "")
        {
            this.ready();
            return;
        }

        this.originalWidth = this.elementWidth / this.creationSize.ratio;
        this.originalHeight = this.elementHeight / this.creationSize.ratio;

        let font = shared.components.CoverThumbText.defaultFont(this.model.fonts, this.data);
        let fontFamily = font ? font.name : "Open Sans";

        var htmlObject = document.createElement('div');
        var fontsize = "4px"; // default font size
        /*var ql_container = fx.dom.find(".Text[data-id="+this.data.id+"] .ql-container");
        if(ql_container != null)
        {
            if (Array.isArray(ql_container))
                ql_container = ql_container[0];
            
            fontsize = ql_container.firstChild.style.fontSize;
        }*/
        // when creating thumb of ThemeLayout, we put some light grey color on texts
        //let bgcolor = (fx.get("app") == "config") ? "#e9e9e9" : this.data.bgcolor;
        let bgcolor = this.data.bgcolor;
            
        htmlObject.innerHTML = 
        `<div id="uuid-ksbmnhly" class="Text BaseComponent Component" data-id="`+this.data.id+`" style="opacity: 1; visibility: visible; outline: none; background-color: `+ bgcolor +`; width: `+Math.round(this.originalWidth)+`px; height: `+Math.round(this.originalHeight)+`px; ">
            <div id="uuid-ksbmnhmg" class="Box Component text ql-container ql-disabled" style="height: inherit; top: 5px; left: 5px; opacity: 1; visibility: visible; position: absolute; width: `+((this.originalWidth)-10)+`px;">
                <div class="ql-editor" data-gramm="false" contenteditable="false" style="font-family: '`+fontFamily+`'; text-align: left; font-size: `+fontsize+`; color: `+ (this.data.color !== undefined ? this.data.color : "")+`;">
                `+content+`
                </div>
            </div>
        </div>`;

        var texts = [];
        var elements = ["span", "strong", "em", "p"];
        var text;
        for (var i = 0; i<elements.length; i++)
        {
            text = fx.dom.find(elements[i], htmlObject);
            if(text != null)
                break;
        }

        if(text === null)
        {
            this.ready();
            return;
        }

        if (text)
        {
            if (Array.isArray(text))
                texts = text;
            else
                texts.push(text);

            for(var i=0 ; i<texts.length; i++)
            {
                texts[i].style.whiteSpace = "pre-wrap";
                texts[i].style.wordBreak = "break-word";
                texts[i].style.margin = 0;
                texts[i].style.padding = 0;
                texts[i].style.lineHeight = 1.34;
            }
        }

        var textContainers = [];
        var textContainer = fx.dom.find("p", htmlObject);
        if(textContainer === null)
        {
            this.ready();
            return;
        }

        if (textContainer)
        {
            if(Array.isArray(textContainer))
                textContainers = textContainer;
            else
                textContainers.push(textContainer);

            for(var i=0 ; i<textContainers.length; i++)
            {
                textContainers[i].style.whiteSpace = "pre-wrap";
                textContainers[i].style.wordBreak = "break-word";
                textContainers[i].style.margin = 0;
                textContainers[i].style.padding = 0;
            }
        }

        let style = ".ql-editor { line-height: 1.34em; font-size-adjust: none;}";
        style += this.fontstyle;
        // A foreignObject only takes XHTML : one tag the XML parser rejects and the whole image fails
        // to load, the text vanishing from the page. The content is serialized as XML rather than
        // patched by hand : innerHTML writes every void element unclosed, and only a bare <br> used
        // to be closed — Quill's empty lines carry <br style="font-size: 5px;">, which left a whole
        // cover without its texts (creation 4268849).
        // The spaces are kept as they are, in pre-wrap like the stage's .ql-editor p and span : several
        // in a row still show, and a line can still break at one. They used to become &nbsp; drawn as a
        // transparent dot, because "pre-warp" (sic) left the white-space normal — but a dot is no place to
        // break, so "Courir POUR ELLES" wrapped as "Courir POUR ELL / ES".
        const serializer = new XMLSerializer();
        const cleanedContent = Array.prototype.map.call(htmlObject.childNodes, (node) => serializer.serializeToString(node)).join("");

        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${Math.round(this.originalWidth)}" height="${Math.round(this.originalHeight)}">
        <foreignObject width="100%" height="100%">
        <style>`+style+`</style>
        <div xmlns="http://www.w3.org/1999/xhtml">${cleanedContent}</div>
        </foreignObject>
        </svg>`;

        window.unescape = window.unescape || window.decodeURI;
        var b64 = window.btoa(unescape(encodeURIComponent(svg)));

        let tempImg = new Image();
        this.on("load", this.drawTextOnCanvas, tempImg);
        this.on("error", this.onLoadError, tempImg);
        tempImg.src = "data:image/svg+xml;base64," + b64;
    }


    drawTextOnCanvas(event)
    {
        // given up on already : the canvas is drawing another page by now
        if (this.late)
            return;

        var img = event.target;

        this.context.save();
        this.context.translate(this.elementX-this.offset, this.elementY-this.voffset);
        this.context.rotate(this.elementRotation*this.TO_RADIANS);
        this.context.translate(-(this.elementX-this.offset), -(this.elementY-this.voffset));
        this.context.drawImage( img, 0, 0, this.originalWidth, this.originalHeight, this.elementX-this.offset, this.elementY-this.voffset, this.elementWidth, this.elementHeight);

        if(this.data.borderid>0)
        {
            this.context.lineWidth = this.data.borderid * this.creationSize.ratio;
            this.context.strokeStyle = this.data.side;
            this.context.strokeRect(this.elementX-this.offset-parseInt(this.data.borderid)/2, this.elementY-this.voffset-parseInt(this.data.borderid)/2, Math.round(this.elementWidth)+parseInt(this.data.borderid), Math.round(this.elementHeight)+parseInt(this.data.borderid));//for white background
        }

        this.context.restore();

        this.ready();
    }

});